/**
 * Zendesk widget helper functions.
 * All functions include guard checks for when Zendesk is not loaded.
 */

declare global {
  interface Window {
    zE?: ((...args: unknown[]) => void) & {
      identify?: (user: { name?: string; email?: string }) => void
      setHelpCenterSuggestions?: (options: { search: string }) => void
    }
  }
}

/**
 * Opens the Zendesk messenger widget.
 * Safe to call even if Zendesk is not loaded.
 */
export function openZendeskWidget(): void {
  if (!window.zE) {
    console.warn('Zendesk widget not loaded')
    return
  }

  try {
    window.zE('messenger', 'open')
  } catch (error) {
    console.warn('Failed to open Zendesk widget:', error)
  }
}

/**
 * Pre-fills the Zendesk widget with user information.
 * @param name - User's display name
 * @param email - User's email address
 */
export function populateZendeskWidgetWithNameAndEmail(
  name = '',
  email = '',
): void {
  if (!window.zE) {
    console.warn('Zendesk widget not loaded')
    return
  }

  try {
    window.zE(function () {
      window.zE!.identify!({
        name,
        email,
      })
    })
  } catch (error) {
    console.warn('Failed to populate Zendesk widget:', error)
  }
}

/**
 * Sets help center suggestions for the Zendesk widget.
 * @param suggestion - Search query for help center
 */
export function populateZendeskSuggestions(suggestion = ''): void {
  if (!window.zE) {
    console.warn('Zendesk widget not loaded')
    return
  }

  try {
    window.zE(function () {
      window.zE!.setHelpCenterSuggestions!({ search: suggestion })
    })
  } catch (error) {
    console.warn('Failed to set Zendesk suggestions:', error)
  }
}
